/**
 *
 * RecapsPage
 *
 */
import { Box, Container, Stack } from '@mui/material';
import { AppActionsContext } from 'app/components/ResponsiveAppBar/AppActionsContext';
import { SetList } from 'app/components/SetList';
import { useSetSearchSlice } from 'app/components/SetSearch/slice';
import { selectSetSearch } from 'app/components/SetSearch/slice/selectors';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface Props {}

export function RecapsPage(props: Props) {
  const { actions } = useSetSearchSlice();
  const dispatch = useDispatch();
  const sets = useSelector(selectSetSearch);
  const { setAppActions } = React.useContext(AppActionsContext);

  React.useEffect(() => {
    dispatch(actions.listSets());
    setAppActions([]);
  }, [actions, dispatch, setAppActions]);

  if (sets.rows && sets.rows.length) {
    return (
      <Container sx={{ padding: 1 }}>
        <SetList rows={sets.rows} />
      </Container>
    );
  }
  return <div>Hello</div>;
}
